import { render, staticRenderFns } from "./CreateTicketPage.vue?vue&type=template&id=59409242&scoped=true&"
import script from "./CreateTicketPage.vue?vue&type=script&lang=js&"
export * from "./CreateTicketPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59409242",
  null
  
)

export default component.exports